import React from 'react';
import { Col, Form, FormInstance, Row } from 'antd';

import { ReminderTypeEnum } from '../common/types';
import { useGetAllUsers } from '../common/useGetAllUsers';

import { FormDatePicker } from './forms/FormDatePicker';
import { FormSelect } from './forms/FormSelect';
import { FormTextArea } from './forms/FormTextArea';

export const ReminderForm: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { data: usersData, isLoading: usersLoading } = useGetAllUsers();

  const reminderTypeOptions = Object.values(ReminderTypeEnum).map((reminderType) => ({
    value: reminderType,
    content: reminderType,
  }));

  const usersOptions =
    !usersLoading && usersData
      ? usersData.results.map((user) => ({
          value: user.id,
          content: `${user.firstName} ${user.lastName}`,
        }))
      : [];

  return (
    <Form form={form} colon={false} layout="vertical">
      <Row gutter={[10, 5]}>
        <Col xs={24} sm={12}>
          <FormTextArea label="Title" name="title" rows={7} required />
        </Col>
        <Col xs={24} sm={12}>
          <FormTextArea label="Reminder note" name="text" rows={7} required />
        </Col>
        <Col xs={24}>
          <FormSelect label="User" name="user" allowClear={false} options={usersOptions} required />
          <FormDatePicker label="Date" name="date" allowClear={false} required />
          <FormSelect name="type" label="Reminder type" allowClear={false} options={reminderTypeOptions} required />
        </Col>
      </Row>
    </Form>
  );
};
